
//const apiurl = "http://api.schoone.de/backend/";
const apiurl = "https://api.evolvejobs.de/schoneboom/api/backend/";
export default apiurl;